module.exports = __webpack_public_path__ + "static/media/logo.408036f9.png";